import { render, staticRenderFns } from "./superWisePerformanceReport.vue?vue&type=template&id=47f8244f&"
import script from "./superWisePerformanceReport.vue?vue&type=script&lang=js&"
export * from "./superWisePerformanceReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports